<script>
import { getParagraph, wrapParagraphs } from "@/common/api/dsn-spelling-rules.service";
import ArticleContent from "@/components/article/ArticleContent.vue";
import DsnSpellingRuleModal from "@/components/modals/DsnSpellingRuleModal.vue";

export default {
  name: "DsnArticleContent",
  components: {
    ArticleContent,
    DsnSpellingRuleModal
  },
  props: {
    articles: {
      type: Array,
      required: true
    },
    hasReadingLines: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true
    }
  },
  data() {
    return {
      activeParagraph: undefined
    };
  },
  methods: {
    wrapParagraphs,
    showRule(paragraph) {
      this.activeParagraph = paragraph;
    },
    hideRule() {
      this.activeParagraph = undefined;
    },
    onClickDelegate(ev) {
      const paragraph = getParagraph(ev.target);

      if (paragraph) {
        this.showRule(paragraph);
      }
    }
  }
};
</script>

<template>
  <ArticleContent>
    <div
      class="article-content__body-container"
      :class="{ 'article-content__body-container--reading-lines': hasReadingLines }"
    >
      <article
        v-for="(article, articleIndex) in articles"
        :key="articleIndex"
        class="article-content__text indentation-container"
      >
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="article-content__html"
          @click.stop.prevent="onClickDelegate($event)"
          v-html="wrapParagraphs(article.html)"
        ></div>
        <!-- eslint-enable vue/no-v-html -->
      </article>
    </div>
    <DsnSpellingRuleModal
      :paragraph="activeParagraph"
      @click-paragraph="showRule($event)"
      @close="hideRule()"
    />
  </ArticleContent>
</template>
